export default function () {
    return (
        <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="3.375" y="9" width="23.625" height="15.75" rx="1.5" stroke="#3EAE60" strokeWidth="1.2" />
            <path
                d="M6.75 21.375V13.375C6.75 12.8227 7.19772 12.375 7.75 12.375H9.125C9.67728 12.375 10.125 12.8227 10.125 13.375V20.375C10.125 20.9273 10.5727 21.375 11.125 21.375H12.5C13.0523 21.375 13.5 20.9273 13.5 20.375V13.375C13.5 12.8227 13.9477 12.375 14.5 12.375H15.875C16.4273 12.375 16.875 12.8227 16.875 13.375V20.375C16.875 20.9273 17.3227 21.375 17.875 21.375H19.25C19.8023 21.375 20.25 20.9273 20.25 20.375V13.375C20.25 12.8227 20.6977 12.375 21.25 12.375H22.625C23.1773 12.375 23.625 12.8227 23.625 13.375V21.375"
                stroke="#3EAE60"
                strokeWidth="1.2"
                strokeLinecap="round"
            />
            <path
                d="M7.875 24.075V27.125C7.875 27.6773 8.32272 28.125 8.875 28.125H29.9375C30.4898 28.125 30.9375 27.6773 30.9375 27.125V18"
                stroke="#3EAE60"
                strokeWidth="1.2"
            />
            <rect x="28.625" y="9.5" width="4.625" height="8" rx="0.5" stroke="#3EAE60" />
            <path
                d="M31.7812 12.0938C31.7812 12.5597 31.4035 12.9375 30.9375 12.9375C30.4715 12.9375 30.0938 12.5597 30.0938 12.0938C30.0938 11.6278 30.4715 11.25 30.9375 11.25C31.4035 11.25 31.7812 11.6278 31.7812 12.0938Z"
                fill="#3EAE60"
            />
            <circle cx="30.9375" cy="15.1875" r="0.5625" fill="#3EAE60" />
        </svg>
    );
}
